import React, { Fragment } from 'react'
import {
    Edit,
    LongTextInput,
    BooleanInput 
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

export const NotificationEdit = ({ permissions, ...props }) => {
    if (permissions === null || permissions.role !== 'admin') {
        return null
    }

    return (
        <Fragment>
            <Title title={"Editar Notificación"} />
            <Edit {...props}>
                <CustomSimpleForm>
                    <LongTextInput  source="comment" label="Comentario" resettable  />
                    <BooleanInput source="is_public_visible" label="Visible en Público" />
                </CustomSimpleForm>
            </Edit>
        </Fragment>
    )
};
